import React from 'react';
import { View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  container: {
    marginTop: 30,
    borderBottomColor: '#2A4494',
    borderBottomWidth: 3
  }
});

const DivisorLine = ({width = '100%'}) => (
  <View style={[styles.container, {width: width}]} />
);

export default DivisorLine;